import Loading from '../../../../Dashboards/Common/Loading';
import { ByBattalion } from './ByBattalion';
import { ByCity } from './ByCity';
import { ByCommand } from './ByCommand';
import { ByCompany } from './ByCompany';
import { ByDepartment } from './ByDepartment';
import { ByNeighbourhood } from './ByNeighbourhood';
import { ByPoliceStation } from './ByPoliceStation';
import { BySectional } from './BySectional';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useRankingsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ByPoliceStation />
                <ByDepartment />
            </div>
            <div className="charts-side-by-side-dashboards">
                <BySectional />
                <ByCity />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ByNeighbourhood />
                <ByBattalion />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ByCommand />
                <ByCompany />
            </div>
        </>
    );
};
